var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlackboardChartThird(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h18v18h-18z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.625 9.9375h6.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 9.9375v-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.25 9.9375v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 15.75-.75-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 15.75.75-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.19375 12.7500001h-10.3875-.00000007c-.8594925 0-1.55625-.6967569-1.55625-1.5562501v-7.3875.00000023c0-.8594925.69675675-1.55625018 1.55625-1.55625018h10.38674997.0000001c.8594925-.00041399 1.5565875.69600693 1.5569999 1.55550018v.00075018 7.38674999-.0000099c.0004199.8594925-.6959967 1.5565875-1.5554922 1.5570096-.0002501 0-.0005001 0-.0007501 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.75 9.9375v-2.25"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackboardChartThird);
export default __webpack_public_path__ + "static/media/blackboard-chart-third.b07a1c739533ba4bc78e54ffd4903389.svg";
export { ForwardRef as ReactComponent };